/**
 * Created by maciej on 22/06/2016.
 */
import {app} from '../app';
import IPromise = angular.IPromise;
import {ITranslationService} from './TranslationService';

export interface IQuestionnaireService {
    get(slug:string, upid:string);
}

export class QuestionnaireService implements IQuestionnaireService {

    private http:ng.IHttpService;
    private q:ng.IQService;
    private translationService:ITranslationService;

    private defaultQuestionnaire: any = {
        id: null,
        title: null,
        meta: {
            logos: {
                practitioner: null,
                company: null,
                position: {
                    mobile: {
                        main: 'luminaLogo',     // by default 'luminaLogo'
                        secondary: 'companyLogo' // by default 'companyLogo'
                    },
                    desktop: {
                        right: 'companyLogo',    // by default 'luminaLogo'
                        left: 'luminaLogo'      // by default 'companyLogo'
                    }
                }
            },
            styles: null
        },
        questions: null,
        logic: null,
    };

    constructor($http:ng.IHttpService, $q:ng.IQService, TranslationService:ITranslationService) {
        this.http = $http;
        this.q = $q;
        this.translationService = TranslationService;
    }

    public get(slug:string, upid:string) {
        if ((slug === undefined || !slug) || (upid === undefined || !upid)) {
            return this.q.reject();
        }

        return this.http({
                method: 'GET',
                url: '/api/questionnaire/pathToId/' + slug,
            })
            .then((value:any) => {

                let id = value.data.id;

                return this.http({
                        method: 'GET',
                    url: '/api/questionnaire/' + id + '/' + upid,
                        params: {
                            locale: this.translationService.getCurrentLanguage().locale
                        }
                    })
                    .then((value) => {
                        var data:any = value.data;
                        data['id'] = id;
                        return <IQuestionnaire>angular.merge(this.defaultQuestionnaire, data);
                    });

            });

    }

    static factory() {
        const factory = ($http:ng.IHttpService, $q:ng.IQService, TranslationService:ITranslationService) =>
            new QuestionnaireService($http, $q, TranslationService);
        factory.$inject = ['$http', '$q', 'TranslationService'];
        return factory;
    }
}

app.factory('QuestionnaireService', QuestionnaireService.factory());